import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const CardWrap = styled(motion.div)`
  position: relative;
  border-radius: ${(p) => p.$radius || '16px'};
  background: #fff;
  border: 1px solid #e8eef3;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.04);
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s;
  height: ${(p) => (p.$fullHeight ? '100%' : 'auto')};

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 16px 40px rgba(14, 107, 60, 0.1);
    border-color: rgba(14, 107, 60, 0.2);
  }
`;

const CardInner = styled.div`
  padding: ${(p) => p.$padding || '28px 24px'};
  height: ${(p) => (p.$fullHeight ? '100%' : 'auto')};
`;

const GlowCard = ({
  children,
  className,
  padding,
  radius,
  fullHeight = false,
  ...motionProps
}) => (
  <CardWrap
    className={className}
    $radius={radius}
    $fullHeight={fullHeight}
    {...motionProps}
  >
    <CardInner $padding={padding} $fullHeight={fullHeight}>
      {children}
    </CardInner>
  </CardWrap>
);

export default GlowCard;
